import * as moment from "moment";

export function createTimeSource(): ITimeSource {
    return new JsDateTimeSource();
}

export interface ITimeSource {
    now(): moment.Moment;
}

class JsDateTimeSource implements ITimeSource {
    public now(): moment.Moment {
        return moment.utc();
    }
}
